function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "46.097%",
  y1: "97.293%",
  x2: "73.385%",
  y2: "-19.281%",
  id: "pin"
}, React.createElement("stop", {
  stopColor: "#FF2DD6",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FF120C",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M50 99.263c6.369-9.122 11.569-17.358 15.594-24.676C72.08 62.79 75 54.25 75 50.074 75 36.218 63.799 25 50 25S25 36.218 25 50.074c0 4.177 2.92 12.717 9.406 24.513C38.431 81.905 43.631 90.14 50 99.263z",
  stroke: "url(#pin)",
  strokeWidth: 50
}), React.createElement("path", {
  d: "M43.031 78.016L24.766 59.859c-.51-.51-.766-1.166-.766-1.968s.255-1.459.766-1.97l4.046-3.937c.51-.583 1.149-.875 1.915-.875.765 0 1.44.292 2.023.875L45 64.234l26.25-26.25c.583-.583 1.258-.875 2.023-.875.766 0 1.404.292 1.914.875l4.047 3.938c.51.51.766 1.167.766 1.969s-.255 1.458-.766 1.968L46.97 78.016c-.51.583-1.167.875-1.97.875-.801 0-1.457-.292-1.968-.875z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 100 141",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.28242b17.svg";
export { ForwardRef as ReactComponent };